/**
 * The rest of a first hearing, arranged when the reader says so.
 *
 * An answer in words arranges only the first bars of a long window (`lib/ask-run`), so the
 * board says which bars these are and what the rest is, and arranges the rest with the same
 * settings and the same take when pressed. Asking again for nothing new does the same.
 */

import { ACTION_LIVE } from "./Chrome";

export interface ArrangeContinueProps {
  /** The bars the first hearing arranged. */
  readonly heard: readonly [number, number];
  /** The window asked for, in words. */
  readonly rest: string;
  onContinue(): void;
}

export default function ArrangeContinue({
  heard,
  rest,
  onContinue,
}: ArrangeContinueProps): JSX.Element {
  return (
    <div className="flex shrink-0 items-center gap-3 border-b border-shell-edge bg-shell-bar px-2.5 py-1.5 text-[11px] text-shell-text">
      <span className="min-w-0 flex-1 truncate">
        Bars {heard[0]}–{heard[1]}, a first hearing of {rest}. Listen, and go on if it is what you
        asked for.
      </span>
      <button type="button" className={ACTION_LIVE} onClick={onContinue}>
        Arrange {rest}
      </button>
    </div>
  );
}
